import { Link } from 'react-router-dom'

export default function ConnectMailboxStep({ onDone }) {
  return (
    <div>
      <p style={{ color: '#aaa', fontSize: 14, lineHeight: 1.6 }}>
        Connect at least one mailbox so we can start warming and sending. Use Google OAuth (one click) or paste IMAP/SMTP credentials.
      </p>
      <div style={{ marginTop: 20 }}>
        <Link
          to="/email-accounts"
          onClick={onDone}
          style={{
            display: 'inline-block', background: '#3b82f6', color: '#fff',
            padding: '10px 18px', borderRadius: 6, textDecoration: 'none',
            fontWeight: 600, fontSize: 14,
          }}
        >
          Open Mailbox Setup
        </Link>
      </div>
      <p style={{ color: '#666', fontSize: 12, marginTop: 20 }}>
        Step marks done automatically once a mailbox is added.
      </p>
    </div>
  )
}
